import { Injectable } from '@angular/core';
import { PaciCardData } from 'app/shared/models';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PaciService {
    private socket: WebSocket | null = null;
    private cardDataSubject = new Subject<PaciCardData>();
    private connectionStatusSubject = new BehaviorSubject<boolean>(false);
    private errorSubject = new Subject<string>();

    constructor() { }

    connect(): void {
        if ((this.socket && this.socket.readyState === WebSocket.OPEN)) {
            console.log('Already connected to PACI Card Reader');
            return;
        }

        try {
            this.socket = new WebSocket(environment.paciWebSocketUrl);

            this.socket.onopen = () => {
                console.log('Connected to PACI Card Reader');
                this.connectionStatusSubject.next(true);
            };

            this.socket.onmessage = (event) => {
                try {
                    const data: PaciCardData = JSON.parse(event.data);
                    console.log('PACI Card Data Received:', data);

                    if (data) {
                        this.cardDataSubject.next(data);
                        this.disconnect();
                    }
                } catch (error) {
                    console.error('Error parsing PACI data:', error);
                    this.errorSubject.next('Failed to parse card data');
                }
            };

            this.socket.onerror = (error) => {
                console.error('PACI WebSocket error:', error);
                this.errorSubject.next('WebSocket connection error');
            };

            this.socket.onclose = () => {
                console.log('Disconnected from PACI Card Reader');
                this.connectionStatusSubject.next(false);
                this.socket = null;
            };
        } catch (error) {
            console.error('Failed to connect to PACI Card Reader:', error);
            this.errorSubject.next('Failed to establish connection');
        }
    }

    disconnect(): void {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.connectionStatusSubject.next(false);
        }
    }

    getCardData(): Observable<PaciCardData> {
        return this.cardDataSubject.asObservable();
    }

    getConnectionStatus(): Observable<boolean> {
        return this.connectionStatusSubject.asObservable();
    }

    getErrors(): Observable<string> {
        return this.errorSubject.asObservable();
    }

    isConnected(): boolean {
        return this.socket !== null && this.socket.readyState === WebSocket.OPEN;
    }

    private hasCardData(): boolean {
        let hasData = false;
        this.cardDataSubject.subscribe({
            next: data => {
                if (data) hasData = true;
            }
        }).unsubscribe();
        return hasData;
    }
}
